export default {
    active_sessions: "Активные сессии",
    ask_for_details_on_response: "Запрашивать детали при ответе",
    browser: "Браузер",
    browser_data: "Данные браузера",
    current_session: "Текущая сессия",
    delete_all_sessions_except_current: "Удалить все сессии, кроме текущей",
    delete_attachment: "Удалить вложение",
    delete_signed: "Удалить подписанный",
    failed_login_attempts: "Неудачные попытки входа",
    finished_sessions: "Завершенные сессии",
    last_use: "Последнее использование",
    login_attempt: "Попытка входа",
    operating_system: "Операционная система",
    password_expires_in_days: "Срок действия вашего пароля истекает сегодня | Срок действия вашего пароля истекает через {day} день | Срок действия вашего пароля истекает через {day} дня | Срок действия вашего пароля истекает через {day} дней",
    password_valid_until_note: "Срок действия текущего пароля до:",
    question_for_women_only: "Вопрос только для женского пола",
    reset_questionnaire_fill: "Сбросить заполнение анкеты",
    sessions: "Сессии",
    tell_more: "Расскажите подробнее",
    wrong_password: "Неверный пароль",
    "2fa_failed": "Ошибка двухфакторной аутентификации"
}
